import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import { FacadeSesionService } from "src/app/services/facade-sesion.service";
import { Alert } from "../../../models/alert";

@Component({
  selector: "lista-modulos-principales",
  templateUrl: "./lista-modulos-principales.component.html",
  styleUrls: ["./lista-modulos-principales.component.scss"],
  animations: [
    // the fade-in/fade-out animation.
    trigger("fadeIn", [
      // the "in" style determines the "resting" state of the element when it is visible.
      state("in", style({ opacity: 1 })),

      // fade in when created. this could also be written as transition('void => *')
      transition(":enter", [style({ opacity: 0 }), animate(300)]),

      // fade out when destroyed. this could also be written as transition('void => *')
      transition(":leave", animate(300, style({ opacity: 0 }))),
    ]),
  ],
})
export class ListaModulosPrincipalesComponent implements OnInit {
  alert: Alert = new Alert();
  year: string = "2020";

  constructor(
    private router: Router,
    private facadeSesionService: FacadeSesionService
  ) {}

  ngOnInit() {
    this.showAlert();
  }
  public seleccionarModulo(
    modulo: "proceso" | "planeacion" | "administración" | "presupuestos"
  ): void {
    switch (modulo) {
      case "proceso":
        this.facadeSesionService.breadcrumbService.actualizarBreadcrumbTipoObra(
          "proceso"
        );
        this.facadeSesionService.usuarioEnSesionService.actualizarTipoConsulta(
          "proceso"
        );
        //this.router.navigate(['/tablero/busqueda-proceso'], { skipLocationChange: true });
        this.router.navigate(["/tablero/consultar-obras"], {
          skipLocationChange: true,
        });
        break;
      case "planeacion":
        this.facadeSesionService.breadcrumbService.actualizarBreadcrumbTipoObra(
          "planeación"
        );
        this.facadeSesionService.usuarioEnSesionService.actualizarTipoConsulta(
          "planeación"
        );
        this.router.navigate(["/tablero/busqueda-planeacion"], {
          skipLocationChange: true,
        });
        break;
      case "administración":
        this.facadeSesionService.breadcrumbService.actualizarBreadcrumbTipoObra(
          null
        );
        this.facadeSesionService.usuarioEnSesionService.actualizarTipoConsulta(
          "administración"
        );
        this.router.navigate(["/tablero/consultar-obras"], {
          skipLocationChange: true,
        });
        break;
      case "presupuestos":
        this.facadeSesionService.breadcrumbService.actualizarBreadcrumbTipoObra(
          null
        );
        this.facadeSesionService.usuarioEnSesionService.actualizarTipoConsulta(
          "administración"
        );
        this.router.navigate(["/tablero-presupuestos"], {
          skipLocationChange: true,
        });
        break;
    }
  }

  showAlert(): void {
    const hostName: string = location.hostname;

    this.alert.selectYear().then((result) => {
      this.saveYearSelected(result);
      if (!hostName.includes(result) && result !== this.year) {
        window.open(
          `https://sctdgc${result === "2020" ? "" : result}.web.app/`,
          "_self"
        );
      }
    });
  }

  async saveYearSelected(year: string): Promise<void> {
    await localStorage.setItem("year", year);
  }
}
